export const byteToMegabyte = (byte) => {
    const megabyteSize = byte / 1024 / 1024;
    return megabyteSize;
};
